import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ScreenInitialRoutingModule } from '@kp/screen-initial/screen-initial-routing.module';

@NgModule({
  declarations: [ScreenInitialRoutingModule.components],
  imports: [CommonModule, ScreenInitialRoutingModule],
})
export class ScreenInitialModule {}
